// extracted by mini-css-extract-plugin
export var gray = "tag-module--gray--f68c3";
export var info = "tag-module--info--62220";
export var newStyle = "tag-module--newStyle--14047";
export var root = "tag-module--root--0f3d2";
export var top = "tag-module--top--6040c";